import React from "react";
import styled from "styled-components";

const ScrollableContainer = styled.div`
  max-height: 75vh;
  width: 300px;
  max-width: 300px;
  overflow-y: auto;
`;

const NavScrollContainer = ({ children, className }) => {
  return <ScrollableContainer className={className}>{children}</ScrollableContainer>;
};

export default NavScrollContainer;
